/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import CurrencyIcon from '../../../components/CurrencyIcon';
import BasicContainer from '../../../components/BasicContainer';

const UnlockLiquidity = ({
  label,
  subLabel,
  onClick,
  disabled,
  className,
  icon,
  isConnectYourAccount,
  isImg,
}) => {
  const { t: translate } = useTranslation();
  if (!isConnectYourAccount) {
    return <></>;
  }

  return (
    <BasicContainer
      className={`${className} ${
        subLabel ? 'py-3' : ''
      } cursor-pointer hover-container bg-lighter ${disabled ? 'disabled-block' : ''} 
      mb-4 mb-md-0`}
      onClick={onClick}>
      <div className="d-flex flex-row align-items-center justify-content-between">
        {isImg && <CurrencyIcon currencyCode={icon} className="m-0 d-flex" />}
        {!Array.isArray(icon) && !isImg && (
          <i
            style={{ width: '1.5rem', height: '1.5rem' }}
            className={`icon ${icon} text-f4 text-white`}
          />
        )}
        {Array.isArray(icon) && !isImg && (
          <span
            style={{ width: '1.5rem', height: '1.5rem' }}
            className={`icon ${icon[0]} text-f4 text-white`}>
            {[...Array(icon[1] + 1).keys()].map((v) => {
              if (v !== 0) {
                return <span key={`item-${v}`} className={`path${v}`} />;
              }
              return '';
            })}
          </span>
        )}

        <div className="col-9 ms-1">
          <p>
            <b>{label || translate('manage_your_accounts_label')}</b>
          </p>
          {subLabel && <p className="text-shadow text-f6">{subLabel}</p>}
        </div>
        <i
          style={{ width: '1rem' }}
          className="icon icon-arrow-next-navigation text-primary text-f4 cursor-pointer"
          role="button"
          aria-label={label || translate('manage_your_accounts_label')}
          tabIndex={0}
          onKeyDown={() => {}}
          onClick={() => {}}
        />
      </div>
    </BasicContainer>
  );
};

export default UnlockLiquidity;

UnlockLiquidity.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  disabled: PropTypes.bool,
  subLabel: PropTypes.string,
  label: PropTypes.string,
  className: PropTypes.string,
  isConnectYourAccount: PropTypes.bool,
  isImg: PropTypes.bool,
};

UnlockLiquidity.defaultProps = {
  subLabel: null,
  label: null,
  disabled: null,
  className: null,
  isConnectYourAccount: true,
  isImg: false,
};
